/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Allocation_Accept_Errormessage2Inputs */

const en_coinvestments_allocation_accept_errormessage2 = /** @type {(inputs: Coinvestments_Allocation_Accept_Errormessage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to accept allocation. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to accept allocation. Please try again." |
*
* @param {Coinvestments_Allocation_Accept_Errormessage2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_allocation_accept_errormessage2 = /** @type {((inputs?: Coinvestments_Allocation_Accept_Errormessage2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Allocation_Accept_Errormessage2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_allocation_accept_errormessage2(inputs)
});
export { coinvestments_allocation_accept_errormessage2 as "coInvestments_allocation_accept_errorMessage" }